const SecondPage = () => {
	return <div>
	<iframe title="ChineseFile" style={{width:"calc(100% - 8px)",height:"calc(100vh - 10px)",marginTop:-80}} src="OGC_ZH.html"></iframe>
	</div>
}
export default SecondPage;